import { GetWindowDimensions, IsMobile } from "./utilties";

(window as any).GetWindowDimensions = GetWindowDimensions;
(window as any).IsMobile = IsMobile;